export const MemSidebarConstant = {
    FEED_REQUEST: "FEED_SIDEBAR_REQUEST",
    FEED_SUCCESS: "FEED_SIDEBAR_SUCCESS",
    FEED_FAILURE: "FEED_SIDEBAR_FAILURE",
};
